import React, { useContext, useEffect, useState } from 'react';
import { UserContext, SignInContext } from 'contexts';
import { navigate, useQueryParams } from 'hookrouter';
import { useApi } from 'hooks';
import { SendFactor, VerifyPasscode, SignIn } from 'api';
import { SigninForm, FactorSelectionForm, VerifyPasscodeForm } from 'forms';
import { Process } from 'common';
import { writToStore } from 'storage';

const SignInPage = () => {
  // queryparams into global state
  const [queryParams] = useQueryParams();
  console.log('SignInPage', queryParams);
  const [userContext, setUserContext] = useContext(UserContext);
  const [, setSignInContext] = useContext(SignInContext);

  useEffect(() => {
    setUserContext({ ...userContext, queryParams });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emptyFactors = { Email: {}, SMS: {}, Call: {} };
  const [step, setStep] = useState(1);
  const [factors, setFactors] = useState(emptyFactors);
  const [stateToken, setStateToken] = useState();
  const [selectedFactor, setSelectedFactor] = useState();

  // API
  const [sendStatus, callSendFactor] = useApi(SendFactor);
  const [verifyStatus, callVerifyPasscode] = useApi(VerifyPasscode);
  const [signInStatus, callSignIn] = useApi(SignIn);

  const onMfaRequired = (stateToken, factors) => {
    setFactors(factors);
    setStateToken(stateToken);
    setStep(2);
  };

  const onSuccess = (accessToken) => {
    setSignInContext(accessToken);
    // todo: redirect to postSignInUrl, if empty redirect to redirectUrl
    navigate('mortgage/sign-in/post-processing');
  };

  const signInUser = async (username, password) => {
    writToStore('login', username);
    const signInResponse = await callSignIn(username, password);
    if (signInResponse) {
      const { AccessToken, Factor, StateToken, Status: loginStatus } = signInResponse;
      switch (loginStatus) {
        case 'MFA_REQUIRED':
          onMfaRequired(StateToken, Factor);
          break;
        case 'SUCCESS':
          onSuccess(AccessToken);
          break;
        default:
      }
    }
  };

  const send = (factor) => {
    setSelectedFactor(factor);
    callSendFactor(stateToken, factor).then((data) => {
      if (data) setStep(3);
    });
  };

  const verify = (passcode) => {
    callVerifyPasscode(stateToken, selectedFactor, passcode).then((data) => {
      if (data) onSuccess(data.accessToken);
    });
  };

  const isNewUser = JSON.parse(queryParams.newUser || true);
  const isLoading = () => sendStatus.isLoading || verifyStatus.isLoading || signInStatus.isLoading;
  const error = () => {
    let tempError = false;
    if (sendStatus.error) tempError = sendStatus.error;
    if (verifyStatus.error) tempError = verifyStatus.error;
    if (signInStatus.error) tempError = signInStatus.error;
    return tempError;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      {step === 1 && (
        <SigninForm
          title="Home Loan Application"
          signUpPath="/mortgage/sign-up"
          isNewUser={isNewUser}
          signIn={signInUser}
        />
      )}
      {step === 2 && <FactorSelectionForm factors={factors} send={send} />}
      {step === 3 && (
        <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
      )}
    </Process>
  );
};

export default SignInPage;
